<template>
  <b-card class="my-2">
    <b-col cols="12" class="pr-0 pl-0 mt-2">
      <div class="d-flex justify-content-end mb-2">
        <b-button
          v-if="canCreateEstablecimiento"
          variant="primary"
          size="sm"
          @click="onCreate"
        >
          Crear Establecimiento
        </b-button>
      </div>
      
      <b-table 
        v-if="!loadingTable && establecimientos.length > 0" 
        striped responsive
        :items="establecimientos" 
        :fields="fieldsTable" 
        sort-by.sync=""
        sort-desc.sync=false 
        sort-direction="asc"
        small
      >

        <template #cell(acciones)="data">
          <div >

            <b-button
              @click="onView(data.item, true )"
              
              variant="info"
              size="sm"
            >
              <font-awesome-icon icon="magnifying-glass" style="color: white;" />
            </b-button>
            
            <b-button
              @click="onView(data.item, false)"
              variant="primary"
              size="sm"
            >
              <i class="fas fa-pen"/>
            </b-button>

          </div>
        </template>
      </b-table>

      <div 
        v-if="establecimientos.length === 0 && !loadingTable"
        class="text-center"
      >
        <EmptyResults/>
      </div>

      <b-skeleton-wrapper v-if="loadingTable">
        <b-skeleton 
          v-for="i in 10"
          :key="i"
          width="100%" 
          height="50px"
        />
      </b-skeleton-wrapper>

    </b-col>


    <b-modal id="modal-establecimiento" size="lg">
      <div>
        <h3 v-if="isViewMode">
          Ver Establecimiento
        </h3>
        <h3 v-else-if="isCreateMode">
          Crear Establecimiento
        </h3>
        <h3 v-else>
          Editar Establecimiento
        </h3>
      </div>
      <b-form>

        <div class="my-1">
          <b> Persona contacto: </b>   
          <v-select 
            id="persona" v-model="selectedPersona" 
            label="text" :options="personas"
            placeholder="Busque aqui por nombre, apellido o cedula" 
            @search="onSearch" :disabled="isViewMode"
          />
        </div>
       
        <hr/> 

        <b-row class="my-1">
          <b-col> 
            <b> Unicodigo: </b> 
            <b-form-input v-model="estabEdit.uniCode" :disabled="isViewMode"/> 
          </b-col>

          <b-col> 
            <b> Nombre: </b> 
            <b-form-input v-model="estabEdit.nombre" :disabled="isViewMode"/>
          </b-col>
        </b-row>

        <hr/>

        <b-row  class="my-1">
          <b-col> 
            <b> Ciudad: </b> 
            <b-form-input v-model="estabEdit.ciudad" :disabled="isViewMode"/>
          </b-col>

          <b-col> 
            <b> Numero Contrato:</b> 
            <b-form-input v-model="estabEdit.numcontrato" :disabled="isViewMode"/> 
          </b-col>
         
        </b-row>
        <hr /> 
        <b-row  class="my-1">
          <b-col> 
            <b> Correo: </b> 
            <b-form-input v-model="estabEdit.correo" :disabled="isViewMode"/> 
          </b-col>

          <b-col> 
            <b> Compania: </b> 
            <b-form-input v-model="estabEdit.compania" :disabled="isViewMode"/>
          </b-col>
        </b-row>

        <hr /> 
        
        <b-row  class="my-1">
          <b-col> 
            <b> Ruc: </b> 
            <b-form-input v-model="estabEdit.ruc" :disabled="isViewMode"/> 
          </b-col>

          <b-col> 
            <b> Telefono: </b> 
            <b-form-input v-model="estabEdit.telefono" :disabled="isViewMode"/> 
          </b-col>

        </b-row>
        <hr /> 
        <b-row  class="my-1">
          <b-col > 
            <b> Direccion: </b> 
            <b-form-input v-model="estabEdit.direccion" :disabled="isViewMode"/>
          </b-col>
          
        </b-row>
        <b-row  class="my-1">
          <b-col> 
            <b> Firma/Sello representante sucursal: </b>   
            <b-form-file 
              v-if="!isViewMode"
              v-model="estabEdit.urlFirmaSello" 
              accept=".jpg, .png"
              @change="validateFileType"
            />
            
            <b-link 
              v-if="isViewMode && estabEdit.urlFirmaSello" 
              class="text-primary col-4"
              @click="onViewFile(estabEdit.urlFirmaSello)"
            >
              <span >Descargar Archivo </span>
            </b-link>
            <label v-if="isViewMode && !estabEdit.urlFirmaSello">
              <b style="color: red;"> No ha subido aun.</b>
            </label>
          </b-col>
        </b-row>
       
     
      </b-form>
      <template v-if="!isViewMode" #modal-footer>
        <b-button variant="primary" @click="onSaveEstablecimiento">
          {{ isCreateMode ? 'Crear Establecimiento' : 'Actualizar Establecimiento' }}
        </b-button>
      </template>
    </b-modal>

    <ModalViewFile
      v-if="fileToView"
      :urlFile="fileToView"
      v-model="isModalFileVisible"
    />
  </b-card>
</template>

<script>

import { ModalViewFile } from '@/shared/components';
import axios             from 'axios';
import rutas             from '@/assets/utils/rutas.json';
import vSelect           from 'vue-select'
import { fileService }   from "@/shared/services";
import actions           from '@/assets/utils/utils';
import { establecimientosService } from '../../services';
import { comprobarRoles } from "@/shared/helpers";
import { ROLES } from "@/shared/constants";

// Mapeo de IPs a nombres de establecimiento
const IP_ESTABLECIMIENTOS = {
  '192.168.30.147': 'SAN JUAN',
  '192.168.2.244': 'SAMBORONDON',
  '192.168.4.243': 'KENNEDY',
  '192.168.200.20': 'ALBORADA'
};

export default {
  name: 'TableEstablecimientos',
  components:{
    vSelect,
    ModalViewFile
  },

  mounted() {
    actions.setearTitulo('Establecimientos')
  },

  data() {
    return {
      establecimientos: [],
      loadingTable: false,
      selectedPersona: null,
      personas: [],
      search : null,
      modalMode : "view",
      fieldsTable:[
     
        { 
          key: 'uniCodigo',         
          label: 'Unicode',          
          sortable: true, 
          thClass: 'text-center',
          tdClass: 'text-center'
        },

        { 
          key: 'Descripcion',         
          label: 'Nombre',          
          sortable: true, 
        },
        
        { 
          key: 'ciudad',         
          label: 'Ciudad',          
          sortable: true, 
        },

        { 
          key: 'acciones',         
          label: 'acciones',          
          sortable: true, 
          
          
        },
      
      ],

      codG: [
        '0000000001', '0000000013', '0000000012', '0000000017', '0000000018', '0000000019', '0000000020'
      ],

      estabEdit : {
        id: null,
        uniCode : null,
        nombre : null,
        ciudad : null,
        numcontrato : null,
        telefono : null,
        direccion : null,
        ruc : null,
        correo : null,
        persona : null,
        compania : null,
        urlFirmaSello: null
      },
      fileToView: null,
      isModalFileVisible: false,
      tipoArchivoInvalido : false,
    }
  },
  computed: {
    isViewMode() {
      return this.modalMode === "view";
    },
    isCreateMode() {
      return this.modalMode === "create";
    },
    canCreateEstablecimiento() {
      return comprobarRoles([ROLES.JEFE_MEDICO]);
    },
  },

  created() {
    this.loadDataTable();
  },

  methods:{
    onCreate() {
      this.modalMode = "create";
      this.resetEstablecimientoForm();
      this.$bvModal.show('modal-establecimiento');
    },

    onViewFile(urlF) { 
      this.fileToView = urlF;
      this.isModalFileVisible = true;
    },
    
    validateFileType(event) {
      this.tipoArchivoInvalido = false
      const file = event.target.files[0];
      const validTypes = ['image/jpeg', 'image/png'];
      if (file && !validTypes.includes(file.type)) {
        this.tipoArchivoInvalido = true
        this.$bvToast.toast('Por favor sube un archivo JPG o PNG.', {
          title: 'Tipo de archivo no permitido',
          variant: 'danger',
          solid: true
        });
        this.estabEdit.urlFirmaSello = null; // reset file input
      }
    },
    async resolveFirmaSelloUrl() {
      if (!this.estabEdit.urlFirmaSello) return "";
      if (typeof this.estabEdit.urlFirmaSello === "string") {
        return this.estabEdit.urlFirmaSello;
      }
      return fileService.upload("firmaSelloEstab", this.estabEdit.urlFirmaSello);
    },

    async onSaveEstablecimiento() {
      if (this.isCreateMode) {
        await this.crearEstablecimiento();
        return;
      }
      await this.actualizarEstablecimiento();
    },

    async actualizarEstablecimiento(){
      if (this.tipoArchivoInvalido) {
        await this.$swal.fire({
          icon : "error",
          text : "Tipo de archivo solo puede ser jpg o png"
        })
        return
      }
      const query = `
        mutation MyMutation(
          $idEstablecimiento: ID!
          $idPersona: ID
          $ruc: String
          $numContrato: String
          $direccion: String
          $descripcion: String
          $correo: String
          $compania: String
          $ciudad: String
          $telefono: String
          $uniCodigo: String
          $urlFirmaSello : String
        ) {
          actualizarEstablecimiento(
            idEstablecimiento: $idEstablecimiento
            idPersona:$idPersona
            ruc: $ruc
            numContrato: $numContrato
            direccion: $direccion
            descripcion: $descripcion
            correo: $correo
            compania: $compania
            ciudad: $ciudad
            telefono: $telefono
            uniCodigo: $uniCodigo
            urlFirmaSello : $urlFirmaSello
          ) {
            status
            message
            establecimiento {
              id
            }
          }
        }`;

      try {
        const urlFirmaSello = await this.resolveFirmaSelloUrl();
        const selectedPersonaId = this.selectedPersona?.value || null;

        const variables = {
          idEstablecimiento: this.estabEdit.id,
          idPersona        : selectedPersonaId,
          ruc              : this.estabEdit.ruc,
          numContrato      : this.estabEdit.numcontrato,
          direccion        : this.estabEdit.direccion,
          descripcion      : this.estabEdit.nombre,
          correo           : this.estabEdit.correo,
          compania         : this.estabEdit.compania,
          ciudad           : this.estabEdit.ciudad,
          telefono         : this.estabEdit.telefono,
          uniCodigo        : this.estabEdit.uniCode,
          urlFirmaSello    : urlFirmaSello
        }

        const response = await axios.post(rutas.axios + "api", { query, variables });
      
        if (response.data.data.actualizarEstablecimiento.status === "success") {
          
          await this.$swal.fire(
            {
              icon : 'success',
              text : 'Establecimiento actualizado!'
            }
          )
          this.$router.go(0)
        } else {
          this.$swal.fire(
            {
              icon : 'error',
              text : 'No se pudo actualizar el establecimiento'
            }
          )
        }

      } catch (error) {
        console.error("Error buscando personas:", error.response ? error.response.data : error.message);
      }
    },

    async crearEstablecimiento() {
      if (this.tipoArchivoInvalido) {
        await this.$swal.fire({
          icon: "error",
          text: "Tipo de archivo solo puede ser jpg o png",
        });
        return;
      }

      if (!this.estabEdit.nombre) {
        await this.$swal.fire({
          icon: "error",
          text: "El nombre del establecimiento es obligatorio",
        });
        return;
      }

      const query = `
        mutation MyMutation(
          $idPersona: ID
          $ruc: String
          $numContrato: String
          $direccion: String
          $descripcion: String!
          $correo: String
          $compania: String
          $ciudad: String
          $telefono: String
          $uniCodigo: String
          $urlFirmaSello : String
        ) {
          crearEstablecimiento(
            idPersona: $idPersona
            ruc: $ruc
            numContrato: $numContrato
            direccion: $direccion
            descripcion: $descripcion
            correo: $correo
            compania: $compania
            ciudad: $ciudad
            telefono: $telefono
            uniCodigo: $uniCodigo
            urlFirmaSello: $urlFirmaSello
          ) {
            status
            message
            establecimiento {
              id
            }
          }
        }`;

      try {
        const urlFirmaSello = await this.resolveFirmaSelloUrl();
        const selectedPersonaId = this.selectedPersona?.value || null;

        const variables = {
          idPersona: selectedPersonaId,
          ruc: this.estabEdit.ruc,
          numContrato: this.estabEdit.numcontrato,
          direccion: this.estabEdit.direccion,
          descripcion: this.estabEdit.nombre,
          correo: this.estabEdit.correo,
          compania: this.estabEdit.compania,
          ciudad: this.estabEdit.ciudad,
          telefono: this.estabEdit.telefono,
          uniCodigo: this.estabEdit.uniCode,
          urlFirmaSello: urlFirmaSello,
        };

        const response = await axios.post(rutas.axios + "api", { query, variables });

        if (response.data.data.crearEstablecimiento.status === "success") {
          await this.$swal.fire({
            icon: "success",
            text: "Establecimiento creado!",
          });
          this.$router.go(0);
        } else {
          this.$swal.fire({
            icon: "error",
            text: "No se pudo crear el establecimiento",
          });
        }
      } catch (error) {
        console.error("Error creando establecimiento:", error.response ? error.response.data : error.message);
      }
    },

    async loadDataTable() {
      this.loadingTable = true;
      try {
        // Detectar IP del host
        let host = window.location.hostname;
        let nombreEstablecimiento = IP_ESTABLECIMIENTOS[host];
        // Si es localhost, asignar Alborada
        if (host === 'localhost' || host === '127.0.0.1') {
          nombreEstablecimiento = 'ALBORADA';
        }

        const estabs = await establecimientosService.getAll();
        // Si no se reconoce la IP, mostrar todos
        if (!nombreEstablecimiento) {
          this.establecimientos = Array.isArray(estabs) ? estabs : [];
          this.loadingTable = false;
          return;
        }

        // Filtrar el establecimiento por nombre (ajusta el campo según tu modelo)
        const estabsList = Array.isArray(estabs) ? estabs : [];
        const estabMatch = estabsList.filter(est => {
          // Ajusta el campo de comparación si es necesario
          return (
            (est.Descripcion && est.Descripcion.toUpperCase() === nombreEstablecimiento) ||
            (est.nombre && est.nombre.toUpperCase() === nombreEstablecimiento)
          );
        });
        this.establecimientos = estabMatch.length > 0 ? estabMatch : [];
      } catch (error) {
        console.error('Error loading establishments table:', error);
        this.establecimientos = [];
      } finally {
        this.loadingTable = false;
      }
    },

   

    onSearch(search) {
      this.search = search
   
      if (this.search.length > 2) {
        this.fetchPersonas(this.search); 
      }
    },


    fetchPersonas(searchQuery) {

      const query = `
        query MyQuery($search : String) {
          allPersona(search: $search) {
            correo
            identificacion
            primerApellido
            primerNombre
            id
          }
        }
      `;

      const variables = { search: searchQuery };

      axios.post(rutas.axios + "api", { query, variables })
        .then(response => {
          if (response.status === 200) {

            this.personas = response.data.data.allPersona.map(item => ({
              value: item.id,
              text: item.primerNombre + " " + item.primerApellido + " (" + item.identificacion + ")"
            }));
          
          } else {
            console.log("error en la busqueda de persona")
          }
        })
    },

    async onView(item, tipo){

      this.modalMode             = tipo ? "view" : "edit";
      this.estabEdit.id          = item.id
      this.estabEdit.uniCode     = item.uniCodigo
      this.estabEdit.nombre      = item.Descripcion
      this.estabEdit.ciudad      = item.ciudad
      this.estabEdit.correo      = item.correo
      this.estabEdit.ruc         = item.ruc
      this.estabEdit.compania    = item.compania
      this.estabEdit.numcontrato = item.numContrato
      this.estabEdit.telefono    = item.telefono
      this.estabEdit.direccion   = item.direccion

      this.estabEdit.urlFirmaSello = item.urlFirmaSello
      
      this.estabEdit.persona = null
      this.selectedPersona = null
      if (item.personaContacto && item.personaContacto.id){

        const persona = await this.fetchPersona(item.personaContacto.id)
        this.estabEdit.persona = { value : persona.id, text : `${persona.primerApellido} ${persona.primerNombre} (${persona.identificacion})` }
        this.selectedPersona = this.estabEdit.persona
      }
    
      this.$bvModal.show('modal-establecimiento')
    },

    resetEstablecimientoForm() {
      this.estabEdit = {
        id: null,
        uniCode: null,
        nombre: null,
        ciudad: null,
        numcontrato: null,
        telefono: null,
        direccion: null,
        ruc: null,
        correo: null,
        persona: null,
        compania: null,
        urlFirmaSello: null,
      };
      this.selectedPersona = null;
      this.personas = [];
      this.search = null;
      this.tipoArchivoInvalido = false;
    },
  
    async fetchPersona(id) {
      
      const query = `
        query MyQuery($idPersona : ID!) {
          getPersonaById(idPersona: $idPersona) {
            id
            primerNombre
            primerApellido
            identificacion
          }
        }
      `;

      const variables = { idPersona: id };

      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });
        return response.data.data.getPersonaById
        
      } catch (error) {
        console.error("Error buscando personas:", error.response ? error.response.data : error.message);
        return null;
      }
    },
  
    
  }
}
</script>
